var map = {
	"./cake.webp": 2386,
	"./correct-ico.webp": 2387,
	"./crown-blue.webp": 2388,
	"./crown.webp": 2389,
	"./pocket.webp": 2390,
	"./present.webp": 2391,
	"./relegation.webp": 2392,
	"./t-deposit.webp": 2393,
	"./t-turnover.webp": 2394,
	"./vip-1.webp": 2395,
	"./vip-2.webp": 2396,
	"./vip-3.webp": 2397,
	"./vip-4.webp": 2398,
	"./vip-5.webp": 2399,
	"./vip-badge.webp": 2400,
	"./vip-bg.webp": 2401,
	"./vip-bonus-bg.webp": 2402,
	"./vip1.webp": 2403,
	"./vip2.webp": 2404,
	"./vip3.webp": 2405,
	"./vip4.webp": 2406,
	"./vip5.webp": 2407,
	"./vip6.webp": 2408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;